<template>
  <main-content-wrapper v-if="!authenticated">
    <h1>
      PRIJAVA
      <span>V Tuš Cash&Carry spletno trgovino</span>
    </h1>
    <v-layout justify-center row wrap fill-height>
      <v-flex xs12 md5 class="elevation-11 login" pl-5 pr-5 pt-4 pb-4 mr-3>
        <h3>PRIJAVITE SE</h3>
        <template v-if="invalid_username_password">
          <v-alert
            :value="true"
            type="error"
          >
            {{ invalid_username_password_message }}
          </v-alert>
          <empty-space/>
        </template>
        <v-form v-model="valid" @submit.prevent="" ref="form">
          <input-field v-model="email" :label="usernameLabel" v-on:keypress.enter="login" autofocus
                       prepend-inner-icon="fa-envelope" :rules="usernameRules"/>
          <password-field v-model="password" :label="passwordLabel" v-on:keypress.enter="login" :rules="passwordRules"
                          required/>
          <p>Ob prejemu naročila želim dokument:
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon size="15" color="primary" v-on="on">fas fa-question-circle</v-icon>
              </template>
              <span>Pri izbiri dokumenta Račun-dobavnica se upoštevajo morebitne pogodbene bonitete.<br/>Pri izbiri dokumenta Blagajniški prejemek se pogodbene bonitete ne upoštevajo, potrebno bo takojšnje plačilo in osebni prevzem.</span>
            </v-tooltip>
          </p>
          <order-document v-model="document"/>
        </v-form>
        <v-btn depressed large block color="primary_action" @click="login" :loading="loading">PRIJAVA</v-btn>
        <router-link class="gray-text" to="/pozabljeno-geslo">Pozabljeno geslo</router-link>
      </v-flex>
      <v-flex xs12 md5 class="gray explanation" pl-5 pr-5 pt-4 ml-3>
        <v-flex class="mb-5">
          <h3 class="text-uppercase">Že imate Tuš Cash & Carry klub kartico?</h3>
          Z registracijo s podatki iz Tuš Cash & Carry klub kartice vam nudimo:
          <ul class="benefits">
            <li>
              <v-icon size="20">far fa-check-circle</v-icon>
              možnost dostave
            </li>
            <li>
              <v-icon size="20">far fa-check-circle</v-icon>
              koriščenje pogodbenih bonitet
            </li>
          </ul>
          <v-btn to="/ustvari/kartica" depressed color="primary_action_green">PRIJAVA S KLUB KARTICO</v-btn>
        </v-flex>
        <v-flex>
          <h3 class="text-uppercase">Brez Tuš Cash & Carry klub kartice?</h3>
          <p>
            Če tudi niste imetnik Tuš Cash & Carry klub kartice lahko oddate naročilo. Ob registraciji si določite geslo
            za prijavo.
          </p>
          <v-btn to="/ustvari/podjetje" depressed color="primary_action_green">REGISTRACIJA BREZ KLUB KARTICE</v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
  </main-content-wrapper>
</template>

<script>
import MainContentWrapper from '../components/MainContentWrapper'
import SplitContent from '../components/SplitContent'
import PasswordField from '../components/PasswordField'
import EmailField from '../components/EmailField'
import InputField from '../components/InputField'
import EmptySpace from '../components/EmptySpace'
import utils from '../store/utils'
import OrderDocument from '../components/OrderDocument'

export default {
  name: 'Login.vue',
  components: { OrderDocument, MainContentWrapper, PasswordField, SplitContent, InputField, EmptySpace, EmailField },
  data: vm => ({
    valid: false,
    email: null,
    password: null,
    document: 1,
    usernameRules: [
      v => v && v.length > 0 || 'Potreben je vnos uporabniškega imena.'
    ],
    passwordRules: [
      v => v && v.length > 0 || 'Potreben je vnos podatka.'
    ]
  }),
  computed: {
    authenticated: utils.vuexBuildSetGet(this, 'auth', 'authenticated'),
    loading: utils.vuexBuildSetGet(this, 'auth', 'loading'),
    invalid_username_password: utils.vuexBuildSetGet(this, 'auth', 'invalid_username_password'),
    invalid_username_password_message: utils.vuexBuildSetGet(this, 'auth', 'invalid_username_password_message'),
    isCardNumber () {
      return this.email != null && this.email.length == 13 && !isNaN(this.email)
    },
    usernameLabel () {
      if (this.isCardNumber) {
        return 'Številka kartice'
      }
      return 'Uporabniško ime (oz. e-naslov)'
    },
    passwordLabel () {
      if (this.isCardNumber) {
        return 'Pin'
      }
      return 'Geslo'
    }
  },
  methods: {
    login () {
      let isValid = this.$refs.form.validate()
      if (isValid) {
        this.$store.dispatch('auth/login', {
          username: this.email,
          password: this.password,
          document_type: this.document
        })
      }
    }
  }
}
</script>

<style scoped>
.login {

}

.gray {
  background-color: #f9f9f9;
  color: #000000;
  letter-spacing: 0.04em;
  font-weight: 350;
}

.gray-text {
  color: #c2c2c2;
}


.benefits {
  padding-left: 5px;
  margin-top: 10px;
  list-style: none;
  line-height: 25px;
}

.benefits .v-icon {
  margin-right: 5px;
  background-color: white;
  color: #23782f;
}

@media only screen and (max-width: 960px) {
  .login.mr-3 {
    margin-right: 0px !important;
  }

  .explanation.ml-3 {
    margin-left: 0px !important;
    margin-top: 40px !important;
    padding-bottom: 20px;
  }
}
</style>
